import Cookies from "js-cookie";
import { useRef, useState, useCallback, useEffect } from "react";
import { globalStorage } from "../helpers";

const useUnit = () => {
  let unitSet = Cookies.get("fin_unit_data") ? Cookies.get("fin_unit_data") : "";
  const isFirstRendered = useRef(false);
  const [showOptionUnit, setShowOptionUnit] = useState(false);
  const [optionUnit, setOptionUnit] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(unitSet);

  const showSelectionUnit = useCallback(() => {
    let unit = Cookies.get("fin_unit_data") ? Cookies.get("fin_unit_data") : "";
    let units = globalStorage.getItem("fin_units") ? globalStorage.getItem("fin_units") : [];
    if (unit === "*") {
      let newUnit;
      newUnit = units?.map((val) => {
        let label = `${val.unit_code} - ${val.name}`;
        return { label, value: val.unit_code };
      });
      setOptionUnit(newUnit);
      setShowOptionUnit(true);
    }
  }, [setOptionUnit, setShowOptionUnit]);

  useEffect(() => {
    if (!isFirstRendered.current) {
      showSelectionUnit();
      isFirstRendered.current = true;
    }
  }, [showSelectionUnit]);

  return { showOptionUnit, optionUnit, selectedUnit, setSelectedUnit, showSelectionUnit };
};

export default useUnit;
